import STREAMED_LIST_REQUEST_CONFIG from '@client-shared/api/streamed-list-request-config.js'
import PfFile from '@client-shared/models/pf-file.model'
import { getResponseData } from '@client-shared/utils/get-response-data.js'

export const getPfFiles = async ({ axios, signal, projectId }) => {
  const response = await axios.get('pf-files', {
    ...STREAMED_LIST_REQUEST_CONFIG,
    signal,
    params: {
      projectid: projectId,
    },
  })

  const data = getResponseData(response)

  if (!data) { return }

  // Freeze Objects to prevent data binding on pfFiles which causes slow performance
  const pfFiles = data.list.map(pfFile => Object.freeze(new PfFile(pfFile)))

  return pfFiles
}

export const getPfFile = async ({ axios, pfFileId }) => {
  // A single file is fetched lazily by PfFileName for whatever references it — including activity
  // rows of a restricted document or a task the user may not read. The server answers 403 for those
  // (NO_ACCESS_TO_FILE), which is an expected outcome that PfFileName renders as "file not found".
  // Without the flag the web error interceptor treats the 403 like lost project access and
  // redirects to the projects list, which took the whole activities tab down.
  const { data } = await axios.get(`pf-files/${pfFileId}`, {
    skipForbiddenRedirect: true,
  })

  return new PfFile(data)
}

export const postPfFile = async ({ axios, _id, projectId, exifDateTimeOriginal, fileLastModifiedAt, s3Key, fileName, mimeType, size, width, height, isClipboardFile }) => {
  const { data } = await axios.post('pf-files', {
    _id,
    s3Key,
    exifDateTimeOriginal,
    fileLastModifiedAt,
    fileName,
    mimeType,
    size,
    width,
    height,
    isClipboardFile,
    projectId,
  })

  return new PfFile(data)
}

export const getSignedDownloadUrl = async ({ axios, pfFileId, contentDisposition = 'attachment', resolution = '', fileName }) => {
  if (![
    'attachment',
    'inline',
  ].includes(contentDisposition)) {
    throw new Error('Invalid contentDisposition')
  }

  const { data } = await axios.get(`pf-files/${pfFileId}/signed-download-url`,
    {
      params: {
        contentDisposition,
        resolution,
        fileName: fileName ? encodeURIComponent(fileName) : undefined,
      },
    },
  )

  return {
    url: data.url,
    actualResolution: data.actualResolution,
  }
}
